import { isNumber } from "lodash";

import { ConstantFormat, DateFns } from "../../../../../../../utils/DateFns";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item?: Order.Model, dateFns?: DateFns): string => {
	const executorArrivalTimestamp =
		item?.executorToOrder?.[0]?.additionalFields?.arrivalTime ||
		item?.additionalFields?.transfer?.lastReceivedOrder
			?.executorToOrder?.[0]?.additionalFields?.arrivalTime;

	if (!isNumber(executorArrivalTimestamp) || !dateFns) return "";

	return dateFns.formatTime(executorArrivalTimestamp, {
		formatTime: ConstantFormat.DMY_DASH,
		isTimezone: true,
	});
};

export default cellProcessing;
